var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconDocument = function SvgIconDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.916 27.052-16.766.364V3.626h10.124c0 1.302 6.309 5.39 6.309 6.685-.006 6.63.333 10.111.333 16.741Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.394 10.25c0 .013-.006.025-.006.037v16.511a.811.811 0 0 1-.811.811H7.423a.817.817 0 0 1-.818-.811V4.202c0-.448.364-.811.818-.811h10.093c.018 0 .036.006.048.012.019 0 .037.006.055.012a.408.408 0 0 1 .182.097l6.418 6.412c.012.006.018.024.03.036a.265.265 0 0 1 .036.042c.06.067.11.152.11.249ZM7.417 4.167v22.626l16.16.006V10.632h-6.055c-.224 0-.412-.157-.412-.381V4.166H7.417Zm10.505.605v5.08h5.086l-5.086-5.08Z",
    fill: "#949191"
  })));
};

export default SvgIconDocument;